import autogiroSubreducer from "../autogiro/reducer";
import autogiroTableActionsSubreducer from "../autogiro/tableActions.reducer";
import {
  accountingSubreducer,
  initialState as accountingInitialState,
} from "./ReducerParts/accounting";
import {
  accountingOrdersSubReducer,
  initialState as ordersInitialState,
} from "./ReducerParts/orders";
import { initialState as autogiroInitialState } from "../autogiro/reducer";

let initialState = {
  ...accountingInitialState,
  ...ordersInitialState,
  ...autogiroInitialState,
};

const accounting = (state = initialState, action) => {
  let intermediateState = state;

  intermediateState = accountingSubreducer(intermediateState, action);
  intermediateState = autogiroSubreducer(intermediateState, action);
  intermediateState = autogiroTableActionsSubreducer(intermediateState, action);
  intermediateState = accountingOrdersSubReducer(intermediateState, action);

  return intermediateState;
};

export default accounting;
